import type { TopProductsResult } from "../api";

export function TopProducts({ data, currency }: { data: TopProductsResult; currency: string }) {
    const max = Math.max(...data.items.map((i) => i.revenue), 1);
    const fmt = (n: number) =>
        n.toLocaleString(undefined, { style: "currency", currency, maximumFractionDigits: 0 });
    return (
        <div className="bg-okiru-panel border border-okiru-muted/15 rounded-xl p-5">
            <h3 className="text-sm uppercase tracking-wide text-okiru-muted mb-4">Top products</h3>
            <ul className="space-y-3">
                {data.items.length === 0 && <li className="text-okiru-muted text-sm">No data in range.</li>}
                {data.items.map((p) => (
                    <li key={p.product_id ?? p.title} className="text-sm">
                        <div className="flex justify-between mb-1">
                            <span className="truncate pr-2">{p.title}</span>
                            <span className="text-okiru-muted whitespace-nowrap">
                                {p.units_sold} × · {fmt(p.revenue)}
                            </span>
                        </div>
                        <div className="h-1.5 bg-okiru-bg rounded">
                            <div
                                className="h-full bg-okiru-accent rounded"
                                style={{ width: `${(p.revenue / max) * 100}%` }}
                            />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
